/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';
import {
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  IconButton,
  TablePagination,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';

function MoradorList({ refresh, onEdit, onMoradorDeleted, moradorNameFilter, imovelIdFilter, showAll }) {
  const { user } = useAuth();
  const [moradores, setMoradores] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  const fetchMoradores = () => {
    let query = `/moradores?page=${page}&limit=${rowsPerPage}`;

    if (moradorNameFilter) {
      query += `&search=${moradorNameFilter}`;
    }

    if (imovelIdFilter) {
      query += `&imovelId=${imovelIdFilter}`;
    }

    if (showAll) {
      query += '&showAll=true';
    }

    api.get(query)
      .then((response) => {
        setMoradores(response.data.data);
        setTotalCount(response.data.totalCount);
      })
      .catch((error) => {
        console.error('Erro ao buscar moradores:', error);
      });
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    fetchMoradores();
  }, [refresh, page, rowsPerPage, moradorNameFilter, imovelIdFilter, showAll]);

  const handleDelete = async (id) => {
    if (window.confirm('Tem certeza que deseja deletar este morador?')) {
      try {
        await api.delete(`/moradores/${id}`);
        onMoradorDeleted();
        fetchMoradores();
      } catch (error) {
        console.error('Erro ao deletar morador:', error);
      }
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <Paper>
      <TableContainer>
        <Table sx={{ minWidth: 650 }} aria-label="moradores table">
          <TableHead>
            <TableRow>
              {(user && user.tipo_usuario === 'admin') && <TableCell>Empresa ID</TableCell>}
              <TableCell>Residencia</TableCell>
              <TableCell>Morador</TableCell>
              <TableCell>Inquilino</TableCell>
              <TableCell>Acoes</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {moradores.map((morador) => (
              <TableRow
                key={morador.id}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                hover
              >
                {(user && user.tipo_usuario === 'admin') && (
                  <TableCell component="th" scope="row">{morador.empresa_id}</TableCell>
                )}
                <TableCell>{morador.imovel_numero ? `Unid. ${morador.imovel_numero} - ${morador.imovel_descricao}` : 'N/A'}</TableCell>
                <TableCell>{morador.pessoa_nome || 'N/A'}</TableCell>
                <TableCell>{morador.is_inquilino ? 'Sim' : 'Nao'}</TableCell>
                <TableCell>
                  <IconButton aria-label="edit" onClick={() => onEdit(morador)}>
                    <EditIcon />
                  </IconButton>
                  <IconButton
                    aria-label="delete"
                    onClick={() => handleDelete(morador.id)}
                  >
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={totalCount}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        labelRowsPerPage="Linhas por pagina:"
        labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
      />
    </Paper>
  );
}

export default MoradorList;

